import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/* eslint-disable max-len */
import { createRef, useContext, useMemo, useState, } from 'react';
import { RetentionModalCTX } from '@widgets/RetentionModal/types/config';
import { Content } from '@widgets/RetentionModal/components/Modal/styled';
import { useCallback } from 'preact/compat';
import { useFormContext, } from 'react-hook-form';
import API from '@widgets/shared/API/connection';
import FormNotices from '@widgets/shared/components/FormNotices';
import TextInput from '@widgets/shared/components/form-controls/TextInput';
import DOMPurify from 'dompurify';
import { Background, SmallPrint, Wrapper } from './styled';
function RetentionForm({ onComplete }) {
    const ref = createRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState(undefined);
    const { background: { src, alt }, title, copy, buttonText, inputText, smallPrint, } = useContext(RetentionModalCTX);
    const { handleSubmit, getValues, formState: { isValid }, setError, } = useFormContext();
    const formValid = useMemo(() => isValid && !isSubmitting, [isValid, isSubmitting]);
    const email = getValues('email');
    const handleSubmitEvent = useCallback(() => {
        setIsSubmitting(true);
        API.retentionRegistration(email)
            .then((res) => {
            const { success, errors, message, successCopy: remoteSuccessCopy, successTitle: remoteSuccessTitle, } = res;
            if (success) {
                console.log('Newsletter registration successful: ', res);
                onComplete(remoteSuccessTitle ?? 'Thank you text here', remoteSuccessCopy ?? 'lorem ipsum dolor sit amet consectetur adipiscing elit ut culpa sed congue voluptate mollit vulputate vel anim lobortis at mazim');
            }
            else {
                errors.forEach((error) => {
                    if (error.field) {
                        // @ts-ignore ignoring as error.field is probably email and shouldn't cause issues even if it isn't...
                        setError(error.field, { message: error.message }, { shouldFocus: true });
                    }
                    if (message) {
                        setErrorMessage(message);
                    }
                });
            }
        })
            .finally(() => {
            setIsSubmitting(false);
        });
    }, [email, onComplete, setError]);
    const handleNoticeClose = useCallback(() => {
        setErrorMessage(undefined);
    }, [setErrorMessage]);
    return (_jsxs(Wrapper, { children: [_jsx(Background, { children: _jsx("img", { src: src, alt: alt }) }), _jsx(Content, { className: "wysiwyg", children: _jsxs("form", { method: "POST", ref: ref, onSubmit: handleSubmit(handleSubmitEvent), noValidate: true, className: "form", children: [errorMessage && (_jsx("div", { style: { marginBottom: '1rem' }, children: _jsx(FormNotices, { message: errorMessage, type: "error", handleClose: handleNoticeClose, closeTimer: 12000 }) })), _jsx("span", { className: "h3", children: title }), _jsx("p", { children: copy }), _jsx(TextInput, { inputAttrs: {
                                id: 'email',
                                name: 'email',
                                type: 'email',
                                placeholder: 'Enter your email',
                            }, labelAttrs: {
                                htmlFor: 'email',
                                text: 'Enter your email',
                                isFieldRequired: true,
                                hidden: true,
                            } }), _jsx(SmallPrint, { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(smallPrint) } }), _jsx("button", { type: "submit", className: "btn btn--secondary btn--full", disabled: !formValid, children: buttonText })] }) })] }));
}
export default RetentionForm;
